import React, { FC, useState } from 'react';
import styles from './index.module.scss';
import BoardColumn from './BoardColumn';
import { Alert, Skeleton } from 'src/common';
import { useTranslation } from 'react-i18next';
import { useWorkspace } from 'src/models/workspace/hooks';
import { useCurrentSidebar } from 'src/shared/InfoSidebar/hooks';
import classNames from 'classnames';
import { NewStatusIdContext, SetNewStatusIdContext } from './context';
import { useSortedWorkspaceStatuses } from 'src/models/workspace/WorkspaceStatus/hooks';

export const BidsBoard: FC = () => {
  const { t } = useTranslation();
  const { data: ws, loading, error } = useWorkspace();
  const sidebarState = useCurrentSidebar();
  const [newStatusId, setNewStatusId] = useState<string | null>(null);
  const sortedStatuses = useSortedWorkspaceStatuses();

  return (
    <>
      {loading && <Skeleton loading active />}
      {error && !loading ? <Alert type={'error'} message={t(error.message || String(error))} /> : null}
      {!loading && !error && ws && (
        <SetNewStatusIdContext.Provider value={setNewStatusId}>
          <NewStatusIdContext.Provider value={newStatusId}>
            <div
              className={classNames(styles.kanban, {
                [styles.sidePanelIsOpen]: !!sidebarState
              })}
            >
              {sortedStatuses.map(status => (
                <BoardColumn key={status.id} status={status} />
              ))}
            </div>
          </NewStatusIdContext.Provider>
        </SetNewStatusIdContext.Provider>
      )}
    </>
  );
};

BidsBoard.displayName = 'BidsBoard';
export default BidsBoard;
